import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum HosAdvanceDirectivesEnum {
    LivingWill = 1,
    PowerOfAttorney = 4,
    PhysicianOrdersForLST = 8,
    MedicalOrdersForLST = 16,
    OtherLegalDocuments = 32
}

export class HosAdvanceDirectivesEnumClass extends EnumWithDescription<HosAdvanceDirectivesEnum> {
    public readonly enum = HosAdvanceDirectivesEnum;
    public readonly enumName: string = "HosAdvanceDirectives";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HosAdvanceDirectivesEnum>> = new Map([
        [
            "Living Will",
            {
                value: HosAdvanceDirectivesEnum.LivingWill,
                name: "LivingWill"
            }
        ],
        [
            "Power of Attorney",
            {
                value: HosAdvanceDirectivesEnum.PowerOfAttorney,
                name: "PowerOfAttorney"
            }
        ],
        [
            "Physician Orders for Life Sustaining Treatment",
            {
                value: HosAdvanceDirectivesEnum.PhysicianOrdersForLST,
                name: "PhysicianOrdersForLST"
            }
        ],
        [
            "Medical Orders for Life Sustaining Treatment",
            {
                value: HosAdvanceDirectivesEnum.MedicalOrdersForLST,
                name: "MedicalOrdersForLST"
            }
        ],
        [
            "Other Legal Documents",
            {
                value: HosAdvanceDirectivesEnum.OtherLegalDocuments,
                name: "OtherLegalDocuments"
            }
        ]
    ]);
}

export const HosAdvanceDirectives = new HosAdvanceDirectivesEnumClass();
